export default __webpack_public_path__ + "static/media/misc-drawerA-768w.36146589.avif";